"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateAppResponseSchema = void 0;
var zod_1 = require("zod");
/**
 * @see {@link https://fe-api-doc.dev.yanolja.in/?api=cx-journey-api#tag/Member/operation/MemberV1Controller_postValidateApp}
 */
var MemberAgreementsForRealMemberSchema = zod_1.z.object({
    email: zod_1.z.boolean().nullable().optional(),
    sms: zod_1.z.boolean().nullable().optional(),
    inactivity: zod_1.z.boolean().nullable().optional(),
    prepayment: zod_1.z.boolean().nullable(),
    nol: zod_1.z.boolean().nullable(),
    fnb: zod_1.z.boolean().nullable(),
});
var MemberAgreementsSchema = zod_1.z.object({
    termOfService: zod_1.z.boolean().nullable(),
    privacy: zod_1.z.boolean().nullable(),
    location: zod_1.z.boolean().nullable(),
    marketingPrivacy: zod_1.z.boolean().nullable(),
    marketingPush: zod_1.z.boolean().nullable(),
    push: zod_1.z.boolean().nullable(),
    concierge: zod_1.z.boolean().nullable(),
    certification: zod_1.z.boolean().nullable(),
    event: zod_1.z
        .object({
        isPromo230927Agreed: zod_1.z.boolean().nullable(),
    })
        .optional(),
    member: MemberAgreementsForRealMemberSchema.optional(),
});
var MemberValidateDataSchema = zod_1.z.object({
    yanowMemberNo: zod_1.z.number(),
    memberNo: zod_1.z.number(),
    hashedMemberNo: zod_1.z.string(),
    nolMemberId: zod_1.z.number(),
    nolMemberProxyId: zod_1.z.string(),
    memberType: zod_1.z.enum(['YANOLJA', 'APPLE', 'KAKAO', 'NAVER', 'UNKNOW']),
    nickName: zod_1.z.string(),
    id: zod_1.z.string(),
    emailReceiveYN: zod_1.z.string(),
    smsReceiveYN: zod_1.z.string(),
    phoneNumYN: zod_1.z.string(),
    phoneNum: zod_1.z.string(),
    token: zod_1.z.string(),
    withdrawYN: zod_1.z.string().optional(),
    faultyStatus: zod_1.z.number().optional(),
    appServiceAgreed: zod_1.z.boolean(),
    agreements: MemberAgreementsSchema,
    adJoinRoute: zod_1.z.string().optional(),
    joinedAtISO8601: zod_1.z.string().nullable(),
    memberClass: zod_1.z.enum(['LEVEL_00', 'LEVEL_01']).nullable(),
    nol: zod_1.z.object({
        isLinked: zod_1.z.boolean(),
    }),
});
exports.ValidateAppResponseSchema = zod_1.z.object({
    result: zod_1.z.string(),
    data: MemberValidateDataSchema,
    is_passwd_change: zod_1.z
        .object({
        passwdExpired: zod_1.z.boolean().optional(),
        redirect: zod_1.z.string().optional(),
        tempToken: zod_1.z.string().optional(),
        tempTokenExpire: zod_1.z.number().optional(),
    })
        .optional(),
});
